import { cloneDeep } from "lodash";

const PUSH_DEVICES = "app/fleetManagement/PUSH_DEVICES";
const SET_DEVICE_TO_EDIT = "app/fleetManagement/SET_DEVICE_TO_EDIT";
const PUSH_DEVICE_KIT_LIST = "app/fleetManagement/PUSH_DEVICE_KIT_LIST";
const RESET_DEVICE_KIT_LIST = "app/fleetManagement/RESET_DEVICE_KIT_LIST";
const SET_CERTIFICATE_URL = "app/fleetManagement/SET_CERTIFICATE_URL";
const SET_FAILED_CERTIFICATE_DUSNS = "app/fleetManagement/SET_FAILED_CERTIFICATE_DUSNS";
const RESET_DEVICES = "app/fleetManagement/RESET_DEVICES";
const SET_LOADING = "app/fleetManagement/SET_LOADING";
const SET_REFRESH = "app/fleetManagement/SET_REFRESH";
const SET_ERROR = "app/fleetManagement/SET_ERROR";
const SET_FWU_FILTERS = "app/fleetManagement/SET_FWU_FILTERS";
const SET_FW_VERSION_FILTERS = "app/fleetManagement/SET_FW_VERSION_FILTERS";
const SET_DEVICE_FILTERS = "app/fleetManagement/SET_DEVICE_FILTERS";

const initialState = {
  devices: null,
  deviceToEdit: null,
  deviceKitList: null,
  certificateUrl: null,
  failedCertificateDusns: [],
  loading: false,
  refresh: false,
  error: null,
  fwuCampaignFilters: {
    devices: null,
    deviceType: null,
    markets: null
  },
  deviceFilters: {
    devices: null,
    deviceType: null,
    groups: null
  },
  fwVersionFilters: {
    devices: null,
    deviceType: null
  }
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case PUSH_DEVICES: {
      const clonedState = cloneDeep(state);

      const devices = clonedState.devices ?? [];

      return {
        ...clonedState,
        devices: [...devices, ...action.payload]
      };
    }

    case RESET_DEVICES: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        devices: null
      };
    }

    case SET_DEVICE_TO_EDIT: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        deviceToEdit: action.payload
      };
    }

    case PUSH_DEVICE_KIT_LIST: {
      const clonedState = cloneDeep(state);

      const deviceKitList = clonedState.deviceKitList ?? [];

      return {
        ...clonedState,
        deviceKitList: [...deviceKitList, ...action.payload]
      };
    }

    case RESET_DEVICE_KIT_LIST: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        deviceKitList: null
      };
    }

    case SET_CERTIFICATE_URL: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        certificateUrl: action.payload
      };
    }

    case SET_FAILED_CERTIFICATE_DUSNS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        failedCertificateDusns: action.payload
      };
    }

    case SET_REFRESH: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        refresh: action.payload
      };
    }

    case SET_LOADING: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        loading: action.payload
      };
    }

    case SET_ERROR: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        error: action.payload
      };
    }

    case SET_FWU_FILTERS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        fwuCampaignFilters: { ...clonedState.fwuCampaignFilters, ...action.payload }
      };
    }

    case SET_FW_VERSION_FILTERS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        fwVersionFilters: { ...clonedState.fwVersionFilters, ...action.payload }
      };
    }

    case SET_DEVICE_FILTERS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        deviceFilters: { ...clonedState.deviceFilters, ...action.payload }
      };
    }

    default: {
      return state;
    }
  }
}

export const pushDevices = (devices) => ({
  type: PUSH_DEVICES,
  payload: devices
});

export const setDeviceToEdit = (device) => ({
  type: SET_DEVICE_TO_EDIT,
  payload: device
});

export const pushDeviceKitList = (deviceKitList) => ({
  type: PUSH_DEVICE_KIT_LIST,
  payload: deviceKitList
});

export const resetDeviceKitList = () => ({
  type: RESET_DEVICE_KIT_LIST
});

export const setCertificateUrl = (certificateUrl) => ({
  type: SET_CERTIFICATE_URL,
  payload: certificateUrl
});

export const setFailedCertificateDusns = (failedDusns) => ({
  type: SET_FAILED_CERTIFICATE_DUSNS,
  payload: failedDusns
});

export const resetDevices = () => ({ type: RESET_DEVICES });

export const setLoading = (loading) => ({ type: SET_LOADING, payload: loading });

export const setRefresh = (refresh) => ({ type: SET_REFRESH, payload: refresh });

export const setError = (error) => ({ type: SET_ERROR, payload: error });

export const setFWUFilters = (filters) => ({ type: SET_FWU_FILTERS, payload: filters });

export const setDeviceFilters = (filters) => ({ type: SET_DEVICE_FILTERS, payload: filters });

export const setFwVersionFilters = (filters) => ({
  type: SET_FW_VERSION_FILTERS,
  payload: filters
});
